import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { styles } from '../../style/style';
import EnhancedTable from './EnhancedTable';

export default function AdminMaintenanceTable (){
    const login = useSelector((state) => state.login.data.payload.login);

    if(!login){
        window.location.href = '/home';
    }

    return (
        <Box >
            <Grid container sx={styles.masterMargin}>
                <Typography id="BacToFanTableMaintTitle" variant="h2" sx ={styles.h2PageTitle}><><FormattedMessage id="maintenanceTable.title" defaultMessage='BAC to FAN Table Maintenance'/></></Typography>
                    <Grid container sx={styles.tablePadding}>
                        <EnhancedTable/>
                    </Grid>
            </Grid>
        </Box>
    );
}





